import { MsalService } from '@azure/msal-angular';

/**
 * Returns the value of the [fieldName] included in the id token claims of the given [authService]
 * If no matching claim is found, undefined is returned
 */
export const tokenClaimsField = (fieldName: string, authService: MsalService): string | undefined => {
  const account = authService.instance.getAllAccounts()?.[0] ?? null;
  if (account === null) {
    return undefined;
  }

  return account.idTokenClaims?.[fieldName] as string | undefined;
};
